import { DentalFormulaType } from 'chaika-enums';

export { DentalFormulaType as FormulaType };

export enum Condition {
    Normal = 'normal',
    Problem = 'problem',
    Treated = 'treated',
    Missing = 'missing',
    Implant = 'implant',
}

export enum ToothNumber {
    Tooth14 = '14',
    Tooth15 = '15',
    Tooth16 = '16',
    Tooth17 = '17',
    Tooth18 = '18',
    Tooth24 = '24',
    Tooth25 = '25',
    Tooth26 = '26',
    Tooth27 = '27',
    Tooth28 = '28',
    Tooth34 = '34',
    Tooth35 = '35',
    Tooth36 = '36',
    Tooth37 = '37',
    Tooth38 = '38',
    Tooth44 = '44',
    Tooth45 = '45',
    Tooth46 = '46',
    Tooth47 = '47',
    Tooth48 = '48',
    Tooth54 = '54',
    Tooth55 = '55',
    Tooth64 = '64',
    Tooth65 = '65',
    Tooth74 = '74',
    Tooth75 = '75',
    Tooth84 = '84',
    Tooth85 = '85',
    Tooth11 = '11',
    Tooth12 = '12',
    Tooth13 = '13',
    Tooth21 = '21',
    Tooth22 = '22',
    Tooth23 = '23',
    Tooth31 = '31',
    Tooth32 = '32',
    Tooth33 = '33',
    Tooth41 = '41',
    Tooth42 = '42',
    Tooth43 = '43',
    Tooth51 = '51',
    Tooth52 = '52',
    Tooth53 = '53',
    Tooth61 = '61',
    Tooth62 = '62',
    Tooth63 = '63',
    Tooth71 = '71',
    Tooth72 = '72',
    Tooth73 = '73',
    Tooth81 = '81',
    Tooth82 = '82',
    Tooth83 = '83',
}

export type FiveZoneToothNumber =
    | ToothNumber.Tooth14
    | ToothNumber.Tooth15
    | ToothNumber.Tooth16
    | ToothNumber.Tooth17
    | ToothNumber.Tooth18
    | ToothNumber.Tooth24
    | ToothNumber.Tooth25
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28
    | ToothNumber.Tooth34
    | ToothNumber.Tooth35
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38
    | ToothNumber.Tooth44
    | ToothNumber.Tooth45
    | ToothNumber.Tooth46
    | ToothNumber.Tooth47
    | ToothNumber.Tooth48
    | ToothNumber.Tooth54
    | ToothNumber.Tooth55
    | ToothNumber.Tooth64
    | ToothNumber.Tooth65
    | ToothNumber.Tooth74
    | ToothNumber.Tooth75
    | ToothNumber.Tooth84
    | ToothNumber.Tooth85;

export type FourZoneToothNumber =
    | ToothNumber.Tooth11
    | ToothNumber.Tooth12
    | ToothNumber.Tooth13
    | ToothNumber.Tooth21
    | ToothNumber.Tooth22
    | ToothNumber.Tooth23
    | ToothNumber.Tooth31
    | ToothNumber.Tooth32
    | ToothNumber.Tooth33
    | ToothNumber.Tooth41
    | ToothNumber.Tooth42
    | ToothNumber.Tooth43
    | ToothNumber.Tooth51
    | ToothNumber.Tooth52
    | ToothNumber.Tooth53
    | ToothNumber.Tooth61
    | ToothNumber.Tooth62
    | ToothNumber.Tooth63
    | ToothNumber.Tooth71
    | ToothNumber.Tooth72
    | ToothNumber.Tooth73
    | ToothNumber.Tooth81
    | ToothNumber.Tooth82
    | ToothNumber.Tooth83;

export type BabyLowerJawToothNumber =
    | ToothNumber.Tooth85
    | ToothNumber.Tooth84
    | ToothNumber.Tooth83
    | ToothNumber.Tooth82
    | ToothNumber.Tooth81
    | ToothNumber.Tooth71
    | ToothNumber.Tooth72
    | ToothNumber.Tooth73
    | ToothNumber.Tooth74
    | ToothNumber.Tooth75;

export type BabyUpperJawToothNumber =
    | ToothNumber.Tooth55
    | ToothNumber.Tooth54
    | ToothNumber.Tooth53
    | ToothNumber.Tooth52
    | ToothNumber.Tooth51
    | ToothNumber.Tooth61
    | ToothNumber.Tooth62
    | ToothNumber.Tooth63
    | ToothNumber.Tooth64
    | ToothNumber.Tooth65;

export type PermanentLowerJawToothNumber =
    | ToothNumber.Tooth48
    | ToothNumber.Tooth47
    | ToothNumber.Tooth46
    | ToothNumber.Tooth45
    | ToothNumber.Tooth44
    | ToothNumber.Tooth43
    | ToothNumber.Tooth42
    | ToothNumber.Tooth41
    | ToothNumber.Tooth31
    | ToothNumber.Tooth32
    | ToothNumber.Tooth33
    | ToothNumber.Tooth34
    | ToothNumber.Tooth35
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38;

export type PermanentUpperJawToothNumber =
    | ToothNumber.Tooth18
    | ToothNumber.Tooth17
    | ToothNumber.Tooth16
    | ToothNumber.Tooth15
    | ToothNumber.Tooth14
    | ToothNumber.Tooth13
    | ToothNumber.Tooth12
    | ToothNumber.Tooth11
    | ToothNumber.Tooth21
    | ToothNumber.Tooth22
    | ToothNumber.Tooth23
    | ToothNumber.Tooth24
    | ToothNumber.Tooth25
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28;

export type MixedLowerJawToothNumber =
    | ToothNumber.Tooth48
    | ToothNumber.Tooth47
    | ToothNumber.Tooth46
    | ToothNumber.Tooth45
    | ToothNumber.Tooth85
    | ToothNumber.Tooth44
    | ToothNumber.Tooth84
    | ToothNumber.Tooth43
    | ToothNumber.Tooth83
    | ToothNumber.Tooth42
    | ToothNumber.Tooth82
    | ToothNumber.Tooth41
    | ToothNumber.Tooth81
    | ToothNumber.Tooth31
    | ToothNumber.Tooth71
    | ToothNumber.Tooth32
    | ToothNumber.Tooth72
    | ToothNumber.Tooth33
    | ToothNumber.Tooth73
    | ToothNumber.Tooth34
    | ToothNumber.Tooth74
    | ToothNumber.Tooth35
    | ToothNumber.Tooth75
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38;

export type MixedUpperJawToothNumber =
    | ToothNumber.Tooth18
    | ToothNumber.Tooth17
    | ToothNumber.Tooth16
    | ToothNumber.Tooth15
    | ToothNumber.Tooth55
    | ToothNumber.Tooth14
    | ToothNumber.Tooth54
    | ToothNumber.Tooth13
    | ToothNumber.Tooth53
    | ToothNumber.Tooth12
    | ToothNumber.Tooth52
    | ToothNumber.Tooth11
    | ToothNumber.Tooth51
    | ToothNumber.Tooth21
    | ToothNumber.Tooth61
    | ToothNumber.Tooth22
    | ToothNumber.Tooth62
    | ToothNumber.Tooth23
    | ToothNumber.Tooth63
    | ToothNumber.Tooth24
    | ToothNumber.Tooth64
    | ToothNumber.Tooth25
    | ToothNumber.Tooth65
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28;

export type HiddenMixedBabyToothNumber =
    | ToothNumber.Tooth18
    | ToothNumber.Tooth17
    | ToothNumber.Tooth16
    | ToothNumber.Tooth48
    | ToothNumber.Tooth47
    | ToothNumber.Tooth46
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38;

export type LowerToothNumber =
    | ToothNumber.Tooth48
    | ToothNumber.Tooth47
    | ToothNumber.Tooth46
    | ToothNumber.Tooth45
    | ToothNumber.Tooth44
    | ToothNumber.Tooth43
    | ToothNumber.Tooth42
    | ToothNumber.Tooth41
    | ToothNumber.Tooth31
    | ToothNumber.Tooth32
    | ToothNumber.Tooth33
    | ToothNumber.Tooth34
    | ToothNumber.Tooth35
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38
    | ToothNumber.Tooth85
    | ToothNumber.Tooth84
    | ToothNumber.Tooth83
    | ToothNumber.Tooth82
    | ToothNumber.Tooth81
    | ToothNumber.Tooth71
    | ToothNumber.Tooth72
    | ToothNumber.Tooth73
    | ToothNumber.Tooth74
    | ToothNumber.Tooth75;

export type UpperToothNumber =
    | ToothNumber.Tooth55
    | ToothNumber.Tooth54
    | ToothNumber.Tooth53
    | ToothNumber.Tooth52
    | ToothNumber.Tooth51
    | ToothNumber.Tooth61
    | ToothNumber.Tooth62
    | ToothNumber.Tooth63
    | ToothNumber.Tooth64
    | ToothNumber.Tooth65
    | ToothNumber.Tooth18
    | ToothNumber.Tooth17
    | ToothNumber.Tooth16
    | ToothNumber.Tooth15
    | ToothNumber.Tooth14
    | ToothNumber.Tooth13
    | ToothNumber.Tooth12
    | ToothNumber.Tooth11
    | ToothNumber.Tooth21
    | ToothNumber.Tooth22
    | ToothNumber.Tooth23
    | ToothNumber.Tooth24
    | ToothNumber.Tooth25
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28;

export type RightToothNumber =
    | ToothNumber.Tooth21
    | ToothNumber.Tooth22
    | ToothNumber.Tooth23
    | ToothNumber.Tooth24
    | ToothNumber.Tooth25
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28
    | ToothNumber.Tooth31
    | ToothNumber.Tooth32
    | ToothNumber.Tooth33
    | ToothNumber.Tooth34
    | ToothNumber.Tooth35
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38
    | ToothNumber.Tooth61
    | ToothNumber.Tooth62
    | ToothNumber.Tooth63
    | ToothNumber.Tooth64
    | ToothNumber.Tooth65
    | ToothNumber.Tooth71
    | ToothNumber.Tooth72
    | ToothNumber.Tooth73
    | ToothNumber.Tooth74
    | ToothNumber.Tooth75;

export type LeftToothNumber =
    | ToothNumber.Tooth11
    | ToothNumber.Tooth12
    | ToothNumber.Tooth13
    | ToothNumber.Tooth14
    | ToothNumber.Tooth15
    | ToothNumber.Tooth16
    | ToothNumber.Tooth17
    | ToothNumber.Tooth18
    | ToothNumber.Tooth41
    | ToothNumber.Tooth42
    | ToothNumber.Tooth43
    | ToothNumber.Tooth44
    | ToothNumber.Tooth45
    | ToothNumber.Tooth46
    | ToothNumber.Tooth47
    | ToothNumber.Tooth48
    | ToothNumber.Tooth51
    | ToothNumber.Tooth52
    | ToothNumber.Tooth53
    | ToothNumber.Tooth54
    | ToothNumber.Tooth55
    | ToothNumber.Tooth81
    | ToothNumber.Tooth82
    | ToothNumber.Tooth83
    | ToothNumber.Tooth84
    | ToothNumber.Tooth85;

export enum ToothZone {
    Root = 'root',
    One = '1',
    Two = '2',
    Three = '3',
    Four = '4',
    Five = '5',
}

export type FourZoneSurfaceNumber = ToothZone.One | ToothZone.Two | ToothZone.Three | ToothZone.Four;
export type FiveZoneSurfaceNumber = ToothZone.One | ToothZone.Two | ToothZone.Three | ToothZone.Four | ToothZone.Five;

export type ZoneAmount = 4 | 5;

export type FourZoneSurfaceCondition = Record<FourZoneSurfaceNumber, Condition>;
export type FiveZoneSurfaceCondition = Record<FiveZoneSurfaceNumber, Condition>;

export type FourZoneSurfaceColors = Record<FourZoneSurfaceNumber, { fill: string; stroke: string }>;
export type FiveZoneSurfaceColors = Record<FiveZoneSurfaceNumber, { fill: string; stroke: string }>;

export type FourZoneToothZones = Exclude<ToothZone, ToothZone.Five>;

export type FiveZoneToothZones = ToothZone;

export enum ChangeTeethAction {
    Remove = 'remove',
    ReplacePermanentToMilk = 'replacePermanentToMilk',
    ReplaceMilkToPermanent = 'replaceMilkToPermanent',
}

interface ToothDataBase {
    isHide?: boolean;
}

// State

export type FourZoneToothStateBase = {
    [key in FourZoneToothZones]: Condition;
};

export type FiveZoneToothStateBase = {
    [key in FiveZoneToothZones]: Condition;
};

export type FourZoneToothState = FourZoneToothStateBase & ToothDataBase;

export type FiveZoneToothState = FiveZoneToothStateBase & ToothDataBase;

export type DentalFormulaStateItem = FourZoneToothState | FiveZoneToothState;

// Selection

type FourZoneToothSelectionBase = {
    [key in FourZoneToothZones]?: boolean;
};

type FiveZoneToothSelectionBase = {
    [key in FiveZoneToothZones]?: boolean;
};

// eslint-disable-next-line sonarjs/redundant-type-aliases
type FourZoneToothSelection = FourZoneToothSelectionBase;

// eslint-disable-next-line sonarjs/redundant-type-aliases
type FiveZoneToothSelection = FiveZoneToothSelectionBase;

export type DentalFormulaSelectionItem = FourZoneToothSelection | FiveZoneToothSelection;

export type HandleSelect = (changes: Partial<DentalFormulaSelection>) => void;

export type DentalFormulaSelection = Partial<
    Record<FiveZoneToothNumber, FiveZoneToothSelection> | Record<FourZoneToothNumber, FourZoneToothSelection>
>;

export type DentalFormulaState = Partial<
    Record<FiveZoneToothNumber, FiveZoneToothState> | Record<FourZoneToothNumber, FourZoneToothState>
>;

export interface SurfaceIconProps {
    handleClick: (zone: FourZoneSurfaceNumber | FiveZoneSurfaceNumber, isModifierPressed: boolean) => void;
    zoneColors: FourZoneSurfaceColors | FiveZoneSurfaceColors;
    dataTest?: string;
}

export interface ToothIconPropsBase {
    toothNumber: ToothNumber;
    crownFill: string;
    crownStrokeColor: string;
    rootFill: string;
    rootStrokeColor: string;
    rootStrokeArray: string;
    rootOpacity: number;
}

export enum ToothBodySite {
    BodySite245566003 = '245566003',
    BodySite245568002 = '245568002',
    BodySite245567007 = '245567007',
    BodySite245570006 = '245570006',
    BodySite245571005 = '245571005',
    BodySite245572003 = '245572003',
    BodySite245574002 = '245574002',
    BodySite245575001 = '245575001',
    BodySite245587008 = '245587008',
    BodySite245586004 = '245586004',
    BodySite245584001 = '245584001',
    BodySite245583007 = '245583007',
    BodySite245582002 = '245582002',
    BodySite245579007 = '245579007',
    BodySite245578004 = '245578004',
    BodySite245577009 = '245577009',
    BodySite245602006 = '245602006',
    BodySite245603001 = '245603001',
    BodySite245604007 = '245604007',
    BodySite245606009 = '245606009',
    BodySite245607000 = '245607000',
    BodySite245608005 = '245608005',
    BodySite245610007 = '245610007',
    BodySite245611006 = '245611006',
    BodySite245600003 = '245600003',
    BodySite245599001 = '245599001',
    BodySite245597004 = '245597004',
    BodySite245596008 = '245596008',
    BodySite245595007 = '245595007',
    BodySite245592005 = '245592005',
    BodySite245591003 = '245591003',
    BodySite245590002 = '245590002',
    BodySite245615002 = '245615002',
    BodySite245616001 = '245616001',
    BodySite245617005 = '245617005',
    BodySite245619008 = '245619008',
    BodySite245620002 = '245620002',
    BodySite245627004 = '245627004',
    BodySite245626008 = '245626008',
    BodySite245624006 = '245624006',
    BodySite245623000 = '245623000',
    BodySite245622005 = '245622005',
    BodySite245637009 = '245637009',
    BodySite245638004 = '245638004',
    BodySite245639007 = '245639007',
    BodySite245641008 = '245641008',
    BodySite245642001 = '245642001',
    BodySite245635001 = '245635001',
    BodySite245634002 = '245634002',
    BodySite245632003 = '245632003',
    BodySite245631005 = '245631005',
    BodySite245630006 = '245630006',
}
